







































import { Component, Mixins, Prop } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import serviceModule from '@/store/modules/ServiceModule'

@Component({
  components: {}
})
export default class ImportMLADialog extends Mixins(BaseVue) {
  @Prop({ default: false })
  public value!: boolean

  @Prop()
  public salesOrgId!: number

  public file?: File = {} as File
  public errors: string[] = []
  public loading = false

  public mounted () {
    this.file = undefined
  }

  public closeDialog (cancelled = true) {
    this.file = undefined
    this.errors = []
    this.loading = false
    this.$emit('close', cancelled)
  }

  public async upload () {
    try {
      this.loading = true
      if (this.file) {
        await serviceModule.customerApi.importCsvForUpdateMLA(this.salesOrgId, {
          data: this.file,
          fileName: this.file.name
        })
        this.displayMessage(this.$t('promotion.uploadSuccess'))
        this.closeDialog(false)
      }
    } catch (error) {
      this.displayError(this.$t('promotion.uploadErrors'))
    }

    this.loading = false
  }
}
